// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"78":"c4defc23","213":"9e7bde2b","475":"ef4ba5a6","580":"c3cb6a68","591":"f0938731","747":"9a57d74c"}[chunkId] + ".chunk.js";
};